import api from 'services/api'
import {
  GET_VISITOR_LOGS_LIST,
  GET_VISITOR_QR_LIST,
  GET_VISITORS_LIST,
  UPDATE_VISITOR_QR_PRINTED,
} from '../endpoints'

export const getVisitorLogsList = async (body) => await api.post(GET_VISITOR_LOGS_LIST, body)
export const getVisitorQRList = async (body) => await api.post(GET_VISITOR_QR_LIST, body)
export const getVisitorsList = async (body) => await api.post(GET_VISITORS_LIST, body)
export const markQRCodePrinted = async (body) => await api.post(UPDATE_VISITOR_QR_PRINTED, body)
